import React from 'react';

const AcceleratorStats = ({ statsData }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 mb-4">
      <div className="bg-white/90 rounded-2xl shadow flex flex-col items-center p-4">
        <span className="text-xs text-gray-500 font-medium mb-1">Total Accelerators</span>
        <span className="text-2xl font-bold text-blue-700">{statsData.totalAccelerators}</span>
      </div>
      <div className="bg-white/90 rounded-2xl shadow flex flex-col items-center p-4">
        <span className="text-xs text-gray-500 font-medium mb-1">Tier A</span>
        <span className="text-2xl font-bold text-red-600">{statsData.tierAAccelerators}</span>
      </div>
      <div className="bg-white/90 rounded-2xl shadow flex flex-col items-center p-4">
        <span className="text-xs text-gray-500 font-medium mb-1">Researching</span>
        <span className="text-2xl font-bold text-blue-600">{statsData.researching}</span>
      </div>
      <div className="bg-white/90 rounded-2xl shadow flex flex-col items-center p-4">
        <span className="text-xs text-gray-500 font-medium mb-1">Applied</span>
        <span className="text-2xl font-bold text-yellow-600">{statsData.applied}</span>
      </div>
      <div className="bg-white/90 rounded-2xl shadow flex flex-col items-center p-4">
        <span className="text-xs text-gray-500 font-medium mb-1">Accepted</span>
        <span className="text-2xl font-bold text-green-600">{statsData.accepted}</span>
      </div>
      <div className="bg-white/90 rounded-2xl shadow flex flex-col items-center p-4">
        <span className="text-xs text-gray-500 font-medium mb-1">Rejected</span>
        <span className="text-2xl font-bold text-red-600">{statsData.rejected}</span>
      </div>
    </div>
  );
};

export default AcceleratorStats; 